import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { TRIAL_DAYS } from '@/config';
import Delete from '@/icons/delete.svg';
import Refresh from '@/icons/refresh.svg';

import {
	CancelSubscriptions,
	ChangePlan,
	RemovePaymentMethod,
	UpdatePaymentMethod
} from '../modals/modals';

export function useOptions() {
	const { t } = useTranslation();
	const [openOption, setOpenOption] = useState(null);

	const options = [
		{
			name: 'cancelSubscription',
			label: t('billing.subscription.cancel'),
			Component: CancelSubscriptions,
			Icon: null
		},
		{
			name: 'changePlan',
			label: t('billing.subscription.cancel'),
			Component: ChangePlan,
			Icon: null
		},
		{
			name: 'removePaymentMethod',
			label: t('common.delete'),
			Icon: Delete,
			Component: RemovePaymentMethod
		},
		{
			name: 'refreshPaymentMethod',
			label: t('common.refresh'),
			Component: UpdatePaymentMethod,
			Icon: Refresh
		}
	];

	return {
		options,
		openOption,
		setOpenOption
	};
}

export function useGetPaymentReference() {
	const { t } = useTranslation();

	function getPaymentReference(data) {
		if (data.trial) {
			return t('billing.subscription.references.trial', {
				trialDays: TRIAL_DAYS
			});
		}

		if (data.service) {
			return t('billing.subscription.references.service');
		}

		if (data.storage) {
			return t('billing.subscription.references.storage');
		}

		return t('billing.subscription.references.generic');
	}

	return getPaymentReference;
}
